import {gpEventKey} from '../analytics/constants'
import GameplayerEventType from '../analytics/event-type'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'

export interface CommonGameAttributes {
  gameCode: string
  gameName: string
  gameOrientation: string
}

export interface GameLoadCompleteAttributes extends CommonGameAttributes {
  loadTime: number
}

const getCommonGameAttributes = ({
  gameCode,
  gameName,
  gameOrientation,
}: {
  gameCode: string
  gameName: string
  gameOrientation: string
}) => {
  return {
    [gpEventKey.gameCode]: gameCode,
    [gpEventKey.gameName]: gameName,
    [gpEventKey.gameOrientation]: gameOrientation,
  }
}

function sendOnGameLoaded({gameCode, gameName, gameOrientation, loadTime}: GameLoadCompleteAttributes) {
  triggerAnalytics(GameplayerEventType.GameLoadingComplete, {
    ...getCommonGameAttributes({gameCode, gameName, gameOrientation}),
    [gpEventKey.loadTime]: loadTime,
  }).sendAll()
}

function sendOnGamePlayStart({gameCode, gameName, gameOrientation}: CommonGameAttributes) {
  triggerAnalytics(
    GameplayerEventType.GamePlayStart,
    getCommonGameAttributes({gameCode, gameName, gameOrientation}),
  ).sendAll()
}

function sendOnGamePlayOver({gameCode, gameName, gameOrientation}: CommonGameAttributes) {
  triggerAnalytics(
    GameplayerEventType.GamePlayOver,
    getCommonGameAttributes({gameCode, gameName, gameOrientation}),
  ).sendAll()
}

function sendOnGamePlayRetry({gameCode, gameName, gameOrientation}: CommonGameAttributes) {
  triggerAnalytics(
    GameplayerEventType.GamePlayRetry,
    getCommonGameAttributes({gameCode, gameName, gameOrientation}),
  ).sendAll()
}

function sendOnGamePlayLevelUp({gameCode, gameName, gameOrientation}: CommonGameAttributes) {
  triggerAnalytics(
    GameplayerEventType.GamePlayLevelUp,
    getCommonGameAttributes({gameCode, gameName, gameOrientation}),
  ).sendAll()
}

function sendOnGameLoading({gameCode, gameName, gameOrientation}: CommonGameAttributes) {
  triggerAnalytics(
    GameplayerEventType.GameLoadingStart,
    getCommonGameAttributes({gameCode, gameName, gameOrientation}),
  ).sendAll()
}

function sendOnGameDelayed({gameCode, gameName, gameOrientation}: CommonGameAttributes) {
  triggerAnalytics(
    GameplayerEventType.GameLoadingDelayed,
    getCommonGameAttributes({gameCode, gameName, gameOrientation}),
  ).sendAll()
}

const analytics = {
  sendOnGameLoaded,
  sendOnGamePlayStart,
  sendOnGamePlayOver,
  sendOnGamePlayRetry,
  sendOnGamePlayLevelUp,
  sendOnGameLoading,
  sendOnGameDelayed,
}

export default analytics
